import { useState, useCallback, useEffect } from 'react';

export const useZebraSerial = () => {
  const [port, setPort] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const connect = async () => {
    const nav: any = navigator;
    if (!nav.serial) {
        setError('Tu navegador no soporta Web Serial. Usa Chrome o Edge.');
        return false;
    }

    setLoading(true);
    setError(null);
    try {
      const selectedPort = await nav.serial.requestPort();
      await selectedPort.open({ baudRate: 9600 }); // Zebra default serial usually 9600 or higher
      
      setPort(selectedPort);
      localStorage.setItem('zebra_serial_paired', 'true');
      return true;
    } catch (err: any) {
      console.error('Serial Connection Error:', err);
      if (err.name === 'NotFoundError') return false;
      setError('Error Serial: ' + (err.message || 'No se pudo conectar'));
      return false;
    } finally {
      setLoading(false);
    }
  };

  const disconnect = useCallback(async () => {
    if (port) {
      try {
        await port.close();
      } catch (e) {
        console.warn('Serial Disconnect error:', e);
      }
      setPort(null);
    }
  }, [port]);

  const printZPL = async (zpl: string) => {
    if (!port || !port.writable) {
      setError('Puerto Serie no listo');
      return false;
    }

    setLoading(true);
    try {
      const writer = port.writable.getWriter();
      const encoder = new TextEncoder();
      const data = encoder.encode(zpl);
      await writer.write(data);
      writer.releaseLock();
      return true;
    } catch (err: any) {
      console.error('Serial Print Error:', err);
      setError('Error al enviar Serial: ' + err.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Auto-connect attempt for Serial
  useEffect(() => {
    const autoConnect = async () => {
      const nav: any = navigator;
      if (nav.serial && localStorage.getItem('zebra_serial_paired') === 'true') {
        try {
          const ports = await nav.serial.getPorts();
          if (ports.length > 0) {
            // Pick the first one or try to match if we had an ID
            const p = ports[0];
            await p.open({ baudRate: 9600 });
            setPort(p);
          }
        } catch (e) {
          console.warn('Serial auto-connect failed', e);
        }
      }
    };
    autoConnect();
  }, []);

  return {
    connect,
    disconnect,
    printZPL,
    isConnected: !!port,
    loading,
    error,
    deviceName: 'Zebra Serial (COM)'
  };
};
